import * as swcHelpers from '@swc/helpers';
import { PrescriptionType } from '../../../../../models/line-item/prescription-glasses.js';
import { getLensDetails } from '../../../../../utils/get-lens-details.js';

function getPrescription(typeDetails) {
    var ref, ref1, ref2, ref3;
    if (typeDetails.isExistingCustomer) {
        return {
            type: PrescriptionType.EXISTING_CUSTOMER
        };
    }
    const hasLeftLensPupillaryDistance = Boolean((ref = typeDetails.newPrescription) === null || ref === void 0 ? void 0 : ref.leftLens.pupillaryDistance);
    const hasRightLensPupillaryDistance = Boolean((ref1 = typeDetails.newPrescription) === null || ref1 === void 0 ? void 0 : ref1.rightLens.pupillaryDistance);
    const hasPupillaryDistanceFile = Boolean(typeDetails.pupillaryDistanceFile);
    const hasLeftAndRightLens = Boolean((ref2 = typeDetails.newPrescription) === null || ref2 === void 0 ? void 0 : ref2.leftLens) && Boolean((ref3 = typeDetails.newPrescription) === null || ref3 === void 0 ? void 0 : ref3.rightLens);
    const hasLeftAndRightPupillaryDistance = hasLeftLensPupillaryDistance && hasRightLensPupillaryDistance;
    if (typeDetails.newPrescription && !typeDetails.isOCRPrescription && typeDetails.prescriptionFile && hasLeftAndRightLens && (hasPupillaryDistanceFile && !hasLeftAndRightPupillaryDistance || !hasPupillaryDistanceFile && hasLeftAndRightPupillaryDistance)) {
        var ref4, ref5, ref6;
        return swcHelpers.objectSpread({
            type: PrescriptionType.PRESCRIPTION_WITH_MANUAL_XOR_FILE_PUPILLARY_DISTANCE,
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: (ref4 = typeDetails.pupillaryDistanceFile) === null || ref4 === void 0 ? void 0 : ref4.fileName
        }, ((ref5 = typeDetails.newPrescription) === null || ref5 === void 0 ? void 0 : ref5.leftLens) && {
            leftLens: getLensDetails(typeDetails.newPrescription.leftLens)
        }, ((ref6 = typeDetails.newPrescription) === null || ref6 === void 0 ? void 0 : ref6.rightLens) && {
            rightLens: getLensDetails(typeDetails.newPrescription.rightLens)
        });
    }
    if (typeDetails.isOCRPrescription && typeDetails.newPrescription && typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
        return {
            type: PrescriptionType.OCR_PRESCRIPTION,
            rightLens: getLensDetails(typeDetails.newPrescription.rightLens),
            leftLens: getLensDetails(typeDetails.newPrescription.leftLens),
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
        };
    }
    if (typeDetails.newPrescription) {
        return {
            type: PrescriptionType.NEW_PRESCRIPTION,
            rightLens: getLensDetails(typeDetails.newPrescription.rightLens),
            leftLens: getLensDetails(typeDetails.newPrescription.leftLens)
        };
    }
    if (typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
        return {
            type: PrescriptionType.PRESCRIPTION_FILE,
            prescriptionFile: typeDetails.prescriptionFile.fileName,
            pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
        };
    }
    return {
        type: PrescriptionType.EMAIL_PRESCRIPTION
    };
}

export { getPrescription };
//# sourceMappingURL=get-prescription.js.map
